/* global angular */

(function () {
  'use strict';

  angular.module('wsLrs.directives').controller('FileUploadCtrl', ['$scope', 'Upload', 'Api', function ($scope, Upload, Api) {
    $scope.uploadFile = function () {
      // In case they didn't select anything here.
      if (!$scope.file) {
        return;
      }
      $scope.uploadFileError = null;
      $scope.uploading = true;
      Upload.upload({
        url: Api.url($scope.uploadFileUrl),
        file: $scope.file
      }).then(function (response) {
        var fileUrl = response.data;
        $scope.uploading = false;
        $scope.uploadFileModal.close(fileUrl);
      }, function (response) {
        $scope.uploading = false;
        $scope.uploadFileError = response.message || response.data.message;
      });
    };
    $scope.cancelUpload = function () {
      $scope.uploadFileModal.dismiss('cancel');
    };
    $scope.onFileSelect = function ($files) {
      // We always get an array despite the fact the control is for a single file
      $scope.file = $files[0];
    };
  }]);
})();
